// Web always runs the latest deploy; over-the-air updates are native-only.
export function currentUpdateLabel() {
  return null;
}
